import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { currentTime } from '@itb-monorepo/helper';

@Component({
  selector: 'lib-timer-countdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './timer-countdown.component.html',
  styleUrl: './timer-countdown.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimerCountdownComponent implements OnDestroy {
  protected startFrom?: number = 0; // start time in seconds
  private subscription: Subscription;
  protected countdown: string;
  private cdr = inject(ChangeDetectorRef);
  protected hours = '00';
  protected minutes = '00';
  protected sec = '00';
  @Input() id?: string = 'timer_countdown_container';
  @Output() timeUp: EventEmitter<void>;

  constructor() {
    this.timeUp = new EventEmitter<void>();
  }

  stop(): void {
    this.ngOnDestroy();
  }

  start(from: number) {
    this.startFrom = from;
    let time = currentTime(this.startFrom);
    this.formatCountdown(time);
    const intv = setInterval(() => {
      time = currentTime(this.startFrom);
      if (time <= 0) {
        clearInterval(intv);
        this.timeUp.emit();
        time = 0;
      }
      this.formatCountdown(time);
    }, 1000);
  }

  protected formatCountdown(seconds: number): void {
    this.hours = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, '0');
    this.minutes = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, '0');
    this.sec = (seconds % 60).toString().padStart(2, '0');
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
